import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';
import {AnesthesiaConfigurationModel} from '../modules/treatment/models/configuration/anesthesia-configuration.model';
import {TreatmentEndoAutofillItemModel} from '../modules/treatment/models/configuration/treatment-endo-autofill-item.model';
import { AnesthesiaEndoAutofillConfigurationModel } from '../modules/treatment/models/configuration/anesthesia-endo-autofill-configuration.model';
import { AnesthesiaEndoExplosionConfigurationModel } from '../modules/treatment/models/configuration/anesthesia-endo-explosion-configuration.model';
import { AnesthesiaEndoExplosionItemConfigurationModel } from '../modules/treatment/models/configuration/anesthesia-endo-explosion-item-configuration.model';

@Injectable({
  providedIn: 'root'
})
export class AnesthesiaService {

  constructor(private http: HttpClient) {
    //
  }

  // Configuration
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  getAnesthesiaConfigurationModels(): Observable<AnesthesiaConfigurationModel> {
    return this.http.get<AnesthesiaConfigurationModel>('api/anesthesia/config');
  }

  //********  AUTO FILL **********/
  saveAnesthesiaAutoFillConfiguration(models: AnesthesiaEndoAutofillConfigurationModel[]): Observable<any> {
    return this.http.post<any>('api/anesthesia/autofill', models);
  }

  saveAnesthesiaAutoFillConfigurationItem(model: AnesthesiaEndoAutofillConfigurationModel): Observable<any> {        
    return model.AnesthesiaEndoAutofillID?
            this.http.put<any>(`api/anesthesia/autofill/${model.AnesthesiaEndoAutofillID}`, model)
            : this.http.post<any>(`api/anesthesia/autofill`, model);
  }

  deleteAnesthesiaAutoFillConfigurationItem(model: AnesthesiaEndoAutofillConfigurationModel): Observable<any> {
    return this.http.delete<any>(`api/anesthesia/autofill/${model.AnesthesiaEndoAutofillID}`);
  }

  //********  EXPLOSION **********/
  //getAnesthesiaExplosionConfiguration(): Observable<AnesthesiaEndoExplosionConfigurationModel[]> {
  //    return this.http.get<AnesthesiaEndoExplosionConfigurationModel[]>('api/anesthesia/explosion');
  //}
  saveAnesthesiaExplosionConfiguration(models: AnesthesiaEndoExplosionConfigurationModel[]): Observable<any> {
    return this.http.post<any>('api/anesthesia/explosion', models);
  }
  
  saveAnesthesiaExplosionConfigurationItem(model: AnesthesiaEndoExplosionConfigurationModel): Observable<any> {    
    return model.AnesthesiaEndoExplosionID?
            this.http.put<any>(`api/anesthesia/explosion/${model.AnesthesiaEndoExplosionID}`, model)
            : this.http.post<any>(`api/anesthesia/explosion`, model);
  }

  deleteAnesthesiaExplosionConfiguration(model: AnesthesiaEndoExplosionConfigurationModel): Observable<any> {
    return this.http.delete<any>(`api/anesthesia/explosion/${model.AnesthesiaEndoExplosionID}`);
  }

  
  deleteAnesthesiaExplosionConfigurationItem(model: AnesthesiaEndoExplosionItemConfigurationModel): Observable<any> {
    return this.http.delete<any>(`api/anesthesia/explosion/${model.AnesthesiaEndoExplosionID}/items/${model.AnesthesiaEndoExplosionItemID}`);
  }
  

}
